export default "__VITE_ASSET__BCjemyfG__"